/**
=========================================================
* Video Question Component
* Question with video player
=========================================================
*/

import { useState } from "react";

// @mui material components
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function VideoQuestion({ question, videoSrc, options }) {
  const [selectedAnswer, setSelectedAnswer] = useState("");

  return (
    <MDBox>
      {/* Question Text */}
      <MDBox mb={3}>
        <MDTypography variant="h6" color="white" fontWeight="medium" mb={2}>
          {question}
        </MDTypography>
      </MDBox>

      {/* Video Player */}
      <MDBox
        mb={3}
        sx={{
          backgroundColor: "transparent",
          borderRadius: "4px",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <video
          src={videoSrc}
          controls
          style={{
            width: "100%",
            maxWidth: "800px",
            height: "auto",
            display: "block",
            objectFit: "contain",
            backgroundColor: "transparent",
          }}
        >
          Your browser does not support the video tag.
        </video>
      </MDBox>

      {/* Answer Options */}
      <FormControl component="fieldset" sx={{ mb: 3 }}>
        <RadioGroup
          value={selectedAnswer}
          onChange={(e) => setSelectedAnswer(e.target.value)}
          sx={{ gap: 1 }}
        >
          {options.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={
                <Radio
                  sx={{
                    color: "rgba(255, 255, 255, 0.7)",
                    "&.Mui-checked": {
                      color: "#ffffff",
                    },
                  }}
                />
              }
              label={
                <MDTypography variant="body2" color="white">
                  {option.label}
                </MDTypography>
              }
            />
          ))}
        </RadioGroup>
      </FormControl>
    </MDBox>
  );
}

export default VideoQuestion;
